<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-va-optimization-details-not-undertrained" v-loading="loading">
    <div class="wy-va-optimization-details-flex-container">
      <div style="display: flex;">
        <el-tooltip  class="item" effect="dark" content="Go Back" placement="bottom">
          <el-button class="el-optimization-details-back" @click="handleBack"></el-button>
        </el-tooltip>
        <div v-html="selectedItem.intent" class="wy-page-title">
        </div>
      </div>
      <el-button v-if="data" class="export-btn" round @click="applyExport">
        <div class="export-icon"></div>
        <span class="export-text">Export</span> 
      </el-button> 
    </div>

    <div v-if="data" class="wy-va-optimization-details-table">
      <div class="div-table-row">
        <div class="wy-va-optimization-details-table-col1 thead">Intent actions</div>
        <div class="wy-va-optimization-details-table-col thead"></div>
      </div>
      <div v-for="(item, key, index) in data" :key="key">
        <div v-if="key=='# times presented'||key=='# utterances'||(item && item.list && item.list.length > 0) ">
          <div v-if="item.list.length == 1" class="div-table-row">
            <div class="wy-va-optimization-details-table-col1">{{key}} <span v-if="key!='# times presented'&&key!='Undertrained intent'">({{item.list.length}})</span></div>
            <div class="intent-action-one-item">
              <div 
                v-if="key!='# times presented'&&key!='Undertrained intent'"
                oncut="return false"
                onpaste="return false"
                ondragenter="return false;" 
                ondragleave="return false;" 
                ondragover="return false;" 
                ondrop="return false;"
                @keydown="handleKeydown"
                @keyup="handleKeyup"
                @click="handleClick($event, 0)"
                @blur="handleBlur($event)"
                contenteditable="false" 
                :title="item.list[0]"
                class="wy-va-optimization-details-table-col div-ellipsis-item">
                {{item.list[0]}}
              </div>
              <div class="div-no-ellipsis-item" v-else>{{item.list[0]}}</div>
            </div>
          </div>

          <div v-else class="div-table-row">
      
            <div class="wy-va-optimization-details-table-col1 collapse-col1">{{key}}
              <span>({{item.list.length}})</span>
              <i v-if="(key!='# utterances' || item.list.length>0)" @click="handleArrowClick(item, key+index)" :class="{'is-active': item.isActive}" class="el-collapse-item__new_arrow el-icon-new-arrow-right"></i>
            </div>
            <div class="intent-action-collapse-item" :class="{'active-collapse-item': item.isActive}">
              <el-collapse @change="handleCollapseClick">
                <el-collapse-item :ref="key+index" @click="collapseItemClick"> 
                    <template slot="title">
                      <div 
                        v-if="(key!='# utterances' || item.list.length>0)"
                        oncut="return false"
                        onpaste="return false"
                        ondragenter="return false;" 
                        ondragleave="return false;" 
                        ondragover="return false;" 
                        ondrop="return false;"
                        @keydown="handleKeydown"
                        @keyup="handleKeyup"
                        @click="handleClick($event, 0)"
                        @blur="handleBlur($event)"
                        contenteditable="false" 
                        :title="item.list[0]"
                        class="div-ellipsis-item" 
                        :class="{'arrow-key': item.list.length > 1}">
                          {{item.list[0]}}
                      </div> 
                      <div v-else class="div-ellipsis-item-no-data">
                        {{item.list[0]}}
                      </div>
                    </template>
                    <div v-for="(listItem, index) in getArrayRest(item.list)" :key="index">
                      <div 
                        oncut="return false"
                        onpaste="return false"
                        ondragenter="return false;" 
                        ondragleave="return false;" 
                        ondragover="return false;" 
                        ondrop="return false;"
                        contenteditable="false"
                        :title="listItem"
                        @keydown="handleKeydown"
                        @keyup="handleKeyup"
                        @click="handleClick($event, index + 1)"
                        @blur="handleBlur($event)"
                        class="div-ellipsis-item">
                          {{listItem}}
                      </div>
                    </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div v-else class="no-result-found">
      <div class="no-data"></div>
      <div class="no-data-title">{{$t('noResultFound.title')}}</div>
      <div class="no-data-content">
        <div class="content-text">
          {{$t('noResultFound.message')}}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';


export default Vue.extend({
  name: 'wy-va-optimization-details-not-undertrained',
  props: ['parent', 'selectedItem'],

  components: {
  
  },
  
  data() {
    return {
      module: this,
      loading: false,
      data: null,
      clickable: false,
      copiableList: [],
      ctrlDown: false,
      // activeTab: 'metrics',
      // isEditTopicName: false,
      // topicName: null,
      // isClickEdit: false,
      // currentItem: null,

    }
  },

  computed: {
    ...mapGetters(['dataModel', 'config', 'tableModel', 'isRoleAllow', 'isReadOnlyUser']),
  },

  watch: {
    // topicName(value) {
    //   if(this.$refs.groupedTopics){
    //     this.$refs.groupedTopics.groupName = value;
    //   } 
    // }
  },

  methods: {
    ...mapActions(['fetchIntentAction', 'exportIntentAction']),

    getArrayRest(list) {
      let newList = []
      list.forEach((item, index) => {
        if(index > 0) {
          newList.push(item)
        }
      })
      return newList
    },

    handleKeydown(e) {
      let ctrlKey = 17;
      let cmdKey = 91;
      let aKey = 65;
      let cKey = 67;
      let rightKey = 39;
      let leftKey = 37;
      if(e.keyCode == ctrlKey || e.keyCode == cmdKey) {
        this.ctrlDown = true;
      }
      if (this.ctrlDown && (e.keyCode == aKey || e.keyCode == cKey) || (e.keyCode == rightKey) || (e.keyCode == leftKey)) {
        return true;
      }
      else {
        e.preventDefault();
        return false;
      }
    },

    handleKeyup(e) {
      let ctrlKey = 17;
      let cmdKey = 91;
      if (e.keyCode == ctrlKey || e.keyCode == cmdKey) {
        this.ctrlDown = false;
      }
    },

    handleClick(e, index) {
      if(!this.clickable) {
        e.preventDefault();
        e.stopPropagation();
        e.target.setAttribute("contenteditable", true);
        setTimeout(()=>{
          e.target.classList.add("on-focus");
          e.target.focus()
        }, 100)
      }
      this.clickable = false;
      this.copiableList.forEach((index)=>{
        this.copiableList[index] = false;
      })
      this.copiableList[index] = true;
    },

    handleBlur(e) {
      e.target.classList.remove("on-focus");
      let temp = e.target.textContent;
      e.target.textContent =""
      setTimeout(()=>{
        e.target.blur()
        e.target.setAttribute("contenteditable", false);
        e.target.textContent = temp;
      }, 100)
    },

    collapseItemClick(){
      return false;
    },

    async applyExport() {
      let actionType = 'export';
      await this.exportIntentAction({intent: this.selectedItem.intent.replace( /(<([^>]+)>)/ig, ''), actionType: actionType})
    },

    async loadIntentActionTable() {
      if((!this.loading && this.dataModel.dateEnd) || this.dataModel.dateEnd) {
        this.loading = true;
        let actionType = 'search';
        let data = await this.fetchIntentAction({intent: this.selectedItem.intent.replace( /(<([^>]+)>)/ig, ''), actionType: actionType});    
        this.data = null;
        if(data && data.intentActionDetail) {
          this.data = data.intentActionDetail;
          this.copiableList = [];
          Object.keys(this.data).forEach(()=>{
            this.copiableList.push(false)
          })
        }
      }
      this.loading = false;    
    },

    refreshUI(item) {
      this.currentItem = item;
      if(this.currentItem) {
        return;
      }
      else {
        this.parent.loading = false;
      }
    },
    handleArrowClick(item, keyIndex){
      this.clickable = true;
      item.isActive = !item.isActive;
      this.$refs[keyIndex][0].$el.querySelector('.arrow-key').click();
    },
    handleCollapseClick(){
      // this.isActive = !this.isActive;
    },
    handleBack() {
      this.$parent.close();
      document.querySelector('.wy-container-main').style.overflowY = 'auto';
    },

  },
  mounted(){
    document.querySelector('.wy-container-main').style.overflowY = 'hidden';
  },
  
  async created() {   
    document.querySelector('.wy-container-main').scrollTop = 0;
    await this.loadIntentActionTable();
  },
});
</script>

<style lang="scss">
.wy-va-optimization-details-not-undertrained {
    min-width: 790px;
    padding-right: 10px;
    width: calc(100% - 54px);
    margin-bottom: 20px;
    position: relative;
    background-color: #FBFDFF;
    bottom: 2px;
    height: calc(100% - 1578px);
    overflow-y: auto; 
    overflow-x: hidden;
    padding: 41px 23px 30px 26px !important;
    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 2px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  .wy-va-optimization-details-flex-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .highlight-keywords {
      background-color: unset;
    }
  }
  .last-one{
    border-bottom: none !important;
  }
  .export-btn {
    box-sizing: border-box;
    border-radius: 5px;
    background: var(--site-button-secondary-btn-background-primary-color);
    color: var(--site-button-secondary-btn-text-primary-color) !important;
    border: 1px solid var(--site-button-secondary-btn-hover-border-primary-color);
    padding: 6px 15px 9px 11px !important;
    width: 90px;
    font-size: 16px !important;
    font-weight: 500 !important;
    height: 39px;
    float: right;
  }
  .export-btn:hover {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-secondary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .export-btn:active {
    background-color: var(--site-button-secondary-btn-pressed-background-primary-color) !important;
  }
  .export-btn:focus {
    border: 1px var(--site-button-secondary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-secondary-btn-text-primary-color) !important;
  }
  .export-icon {
    background: var(--icon_action_export);
    height: 17px;
    width: 13px;
    position: relative;
    top: 2px;
    height: 17px;
    width: 13px;
    display: inline-block;
    background-repeat: no-repeat;
  }
  .export-text {
    position: relative;
    bottom: 1px;
    left: 5px;
  }
  .el-collapse-item__arrow {
    display: none !important;
  }
  .el-collapse {
    width: 100%;
    border-top: none !important;
  }

  .wy-va-optimization-details-table-col.thead,.wy-va-optimization-details-table-col1.thead{
    padding: 18.5px 25px !important;
    font-size: 14.5px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    font-weight: 500;
    color: var(--site-font-secondary-color);
  }
  .el-collapse-item {
    max-height: 200px;
    margin-left: 15px;
    overflow-y: auto;
        &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 2px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#FFF;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
    }
  }
  .el-collapse-item.is-active {
    // padding-top: 10px;
  }
  .el-collapse-item__header {
    border-bottom: none !important;  
    font-size: 14.22px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: var(--site-font-tertiary-color);
    font-weight: 400;
    // padding-left: 15px !important;
    // padding-right: 15px !important;
    height: 36px;
    background-color: #FFF;
    padding-top: 10px;
  }
  .el-collapse-item__wrap {
    border-bottom: none !important;
    // background-color: #FBFDFF;
    background-color: #FFF;
    .el-collapse-item__content {
      font-size: 14.22px;
    }
  }
  .el-collapse-item__content{
    margin-bottom: 0px !important;
    // padding-left: 15px !important;
    // padding-right: 15px !important;
    padding-bottom: 0px !important;
  }
  .el-collapse-item__content > div {
    height: 50px;
    display: flex;
    align-items: center;
    width: 100%;
    line-height: 1.5;
    outline: none;
  }
  .el-collapse-item__new_arrow {
    margin: 0 8px 0 11px;
    position: relative;
    top: 2px;
  }
  .intent-action-collapse-item{
    padding: 0px !important;

    .div-ellipsis-item {
      // width: 98%;
      width: fit-content;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
      text-overflow: ellipsis;
      outline: none;
      line-height: 1.5;
      padding: 5px 10px;
      border: 2px solid transparent;
      position: relative;
      top: -5px;
      margin-right: 15px;
    }
    .div-ellipsis-item-no-data {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      outline: none;
      line-height: 1.5;
      padding: 5px 10px;
      border: 2px solid transparent;
      position: relative;
      top: -5px;
      height: 31px;
      cursor: default;
    }
    div.arrow-key {
      line-height: 1.5;
    }
    .div-ellipsis-item.on-focus {
      // outline: none;
      border: 2px solid #214586;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: unset;
      border-radius: 5px;
    }
    pre.on-focus {
      font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    }
  }
  .el-icon-new-arrow-right:before {
    content: "";
    background-image: url('../../assets/icons/icon_intent_action_arrow.svg');
    background-size: 60%;
    background-position-x: 3px;
    background-position-y: 6px;
    background-repeat: no-repeat;
    height: 16px;
    width: 16px;
    display: inline-block;
    cursor: pointer;
    border-radius: 30px;
    background-color: #f2f2f2;
    border: 0px;
  }
  .el-collapse-item__new_arrow.is-active {
    transform: rotate(180deg) !important;
  }
  .div-table-row {
    display: flex;
    width: 100%;
    // width: calc(100% - 1000px);
    // min-width: 1300px;
    clear: both;
  }
  
  .wy-va-optimization-details-table-col1{
    float: left; /* fix for  buggy browsers */
    display: table-column;         
    width: 13%;         
    border-bottom: 1px solid #CAD2DA;
    border-right: 1px solid #CAD2DA;
    max-width: 220px;
    min-width: 220px;
    
    padding: 28.5px 25px !important;
    font-size: 14.22px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: var(--site-font-tertiary-color);
    font-weight: 400;
  }
  .wy-va-optimization-details-table-col {
    float: left; /* fix for  buggy browsers */
    display: table-column;         
    width: 87%;
    border-bottom: 1px solid #CAD2DA;
    display: flex;
    align-items: center;

    padding: 12.5px 25px !important;
    font-size: 14.22px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: var(--site-font-tertiary-color);
    font-weight: 400;
  }
  .wy-va-optimization-details-table-col.div-ellipsis-item {
    // width: 98%;
    width: fit-content;
    display: inline-block;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    outline: none;
    line-height: 1.5;
    padding: 5px 10px !important;
    border: 2px solid transparent;
  }
  .wy-va-optimization-details-table-col.div-ellipsis-item.on-focus {
    // outline: none;
    border: 2px solid #214586;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: unset;
    border-radius: 5px;
  }
  pre.on-focus {
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
  }
  .collapse-col1{
    // padding-right: 17px !important;
  }
  .el-collapse {
    border-bottom: 1px solid transparent;
  }
  .intent-action-one-item{
    float: left; /* fix for  buggy browsers */
    display: table-column;         
    width: calc(100% - 271px);
    border-bottom: 1px solid #CAD2DA;
    display: flex;
    align-items: center;
    padding: 0px 15px !important;
    font-size: 14.22px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: var(--site-font-tertiary-color);
    font-weight: 400;

    .div-no-ellipsis-item {
      padding: 0px 15px 0px 15px;
    }
  }
  .intent-action-collapse-item{
    float: left; /* fix for  buggy browsers */
    display: table-column;         
    width: calc(100% - 271px);
    border-bottom: 1px solid #CAD2DA;
    display: flex;
    align-items: center;
    
    padding: 0px !important;
    font-size: 14.22px;
    font-family: 'Helvetica Neue', Arial, Helvetica, sans-serif;
    color: var(--site-font-tertiary-color);
    font-weight: 400;
  }
  .wy-page-title{
    margin-bottom: 0 !important;
    margin-left: 10px !important;
  }
  
  .el-button {
    padding: 10px 15px 20px 15px;
    margin-left: 0px;
    margin-right: 0px;
  }
  .el-optimization-details-back {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_back.svg') !important;
    background-size: 35px;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    background-color: #f2f2f2;
    height: 35px;
    width: 35px;
    border: 0px;
  }
  .wy-va-optimization-details-table {
    margin-top: 37px;
    border-radius: 5px;
    border: 1px solid #CAD2DA;
    // display: table;         
    width: 100%;      
    // max-width: 1249px;
    border-bottom: none !important;
    background-color: #FFF;
  }
  .el-optimization-details-back:hover {
    background-color: #ebf4fd !important;
    // background-color: lightblue;
    background-position-y: 0px;
    background-position-x: 0px;
  }
  .no-topic-content {
    color: var(--site-font-primary-color);
    background-color: transparent;
    margin-bottom: 3px;
    height: calc(100vh - 460px);

    .no-data {
      text-align: center;
      display: block;
      border: none;
      // height: 130px;
      height: 120px;
      margin-top: 100px;
      background-position-x: 50%;
      background-repeat: no-repeat;
      background-size: 100px;
      background-image: url('../../assets/icons/icon_no_data.svg');
    }
    .no-data-title {
      width: 100%;
      margin-top: 0px;
      text-align: center;
      font-size: 20px;
      color: var(--site-font-primary-color) !important;
      font-weight: 600;
    }
    .no-data-content-first-row {
      width: 100%;
      text-align: center;
      color: var(--site-font-primary-color) !important;
      padding-top: 16px;
      font-size: 14px;
      font-weight: 500;
    }
    .no-data-content-second-row {
      width: 100%;
      text-align: center;
      color: var(--site-font-primary-color) !important;
      font-size: 14px;
      font-weight: 500;
    }
  }

  
  .el-loading-mask {
    height: unset !important;
    opacity: unset;
    background-color: unset;
    .el-loading-spinner {
      top: 35%;
      background: var(--site-loading-icon);
      background-repeat: no-repeat;
      background-size: 25px;
      background-position: center;    
    }
    .el-loading-spinner .circular {
      display: unset !important;
    }
  }
}

.intent-action-detail-tooltips {
  max-width: 300px;
}
</style>